import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, CheckIcon, ChevronRightIcon, PlusIcon, SearchIcon } from 'lucide-react';
import { FoundPetDialog } from '../components/animaux/FoundPetDialog';
import { PetAtna, PetRules } from '../components/animaux/PetAtna';
import { VetConnect } from '../components/animaux/VetConnect';
import { petTodos, pets } from '../data/animaux';
export function MesAnimaux() {
  const [foundOpen, setFoundOpen] = useState(false);
  const todos = pets.flatMap(pet => (petTodos[pet.id] ?? []).map(todo => ({
    ...todo,
    pet
  })));
  return <main className="bg-white" data-id="element-1985" data-mp="20n7n7pjh7b44">
      <div className="mx-auto max-w-[1000px] px-5 py-12 lg:px-10 lg:py-16" data-id="element-1986" data-mp="20m691c75y8i6">
        <nav aria-label="Breadcrumb" className="flex items-center gap-1.5 text-sm text-slate-500" data-id="element-1987" data-mp="1vomjhg50m9ax">
          <Link to="/" className="font-semibold text-ville-deep hover:text-ville-indigo" data-id="element-1988" data-mp="2alx53ibdgvkd">
            Home
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-1989" data-mp="25nc43goaq7uv" />
          <span aria-current="page" data-id="element-1990" data-mp="1jl06llvaktqi">My pets</span>
        </nav>

        <header className="mt-4" data-id="element-1991" data-mp="1ojbf9t9uoy75">
          <h1 className="text-4xl font-extrabold tracking-tight text-ville-navy lg:text-5xl" data-id="element-1992" data-mp="1oijkulrzp6ig">My pets</h1>
          <p className="mt-2 max-w-2xl text-[17px] text-slate-600" data-id="element-1993" data-mp="1sjv9anz4nlp2">
            Your pets, their licences and what matters — all in one place.
          </p>
        </header>

        <div className="mt-8" data-id="element-1994" data-mp="22jchpd5rkdoq">
          <PetAtna data-id="element-1995" data-mp="22ib2cwhpt517" />
        </div>

        <section aria-labelledby="pets-list-title" className="mt-14" data-id="element-1996" data-mp="22gzwmr4pln7g">
          <h2 id="pets-list-title" className="text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-1997" data-mp="27gmcz9fu3jkh">
            My pets
          </h2>

          <ul className="mt-5 grid gap-4 sm:grid-cols-2" data-id="element-1998" data-mp="2gahjaksozg1p">
            {pets.map(pet => <li key={pet.id} className="flex" data-id="element-1999" data-mp="2g9pkl13st277">
                <Link to={`/my-pets/${pet.id}`} className="group flex w-full items-center gap-4 rounded-3xl border border-slate-200 bg-white p-4 transition-colors duration-150 ease-ville hover:border-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-2000" data-mp="2la3teld84g6a">
                  <img src={pet.photo} alt={pet.name} className="h-24 w-24 shrink-0 rounded-2xl object-cover" data-id="element-2001" data-mp="l7m8hbdq7ies" />
                  <div className="min-w-0 flex-1" data-id="element-2002" data-mp="zwidezkhkfb6">
                    <p className="text-lg font-extrabold text-ville-navy" data-id="element-2003" data-mp="zybkuh2xb3k8">{pet.name}</p>
                    <p className="text-sm text-slate-500" data-id="element-2004" data-mp="v47d3vlu2ri3">
                      {pet.breed} · {pet.age}
                    </p>
                    <p className="mt-2 inline-flex rounded-full bg-ville-indigo-soft px-3 py-1 text-xs font-bold text-ville-indigo" data-id="element-2005" data-mp="14vbt8yn8wiei">
                      Licence active
                    </p>
                    <p className="mt-2 font-mono text-xs tracking-widest text-slate-500" data-id="element-2006" data-mp="1isqlsc8sp6ap">{pet.medal}</p>
                    <p className="text-xs text-slate-500" data-id="element-2007" data-mp="3kmg5j5l858fl">Valid until: {pet.validUntil}</p>
                    <span className="mt-3 inline-flex items-center gap-1.5 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville group-hover:text-ville-indigo" data-id="element-2008" data-mp="3koapohoo8wim">
                      View the card
                      <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-2009" data-mp="2045l79nztccb" />
                    </span>
                  </div>
                </Link>
              </li>)}

            <li className="flex" data-id="element-2010" data-mp="1ldg79zj5dj4r">
              <button type="button" className="flex w-full items-center gap-4 rounded-3xl border-2 border-dashed border-slate-300 p-6 text-left text-slate-500 transition-colors duration-150 ease-ville hover:border-ville-indigo hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-2011" data-mp="1qe3x4hvn3txe">
                <span className="grid h-12 w-12 place-items-center rounded-full bg-slate-50" aria-hidden="true" data-id="element-2012" data-mp="12hq1s2c0a4m4">
                  <PlusIcon className="h-6 w-6" data-id="element-2013" data-mp="17g9r8cpt5yj8" />
                </span>
                <span className="text-[15px] font-bold text-ville-navy" data-id="element-2014" data-mp="2wufzyw9epzzb">Add a pet</span>
              </button>
            </li>

            <li className="flex" data-id="element-2015" data-mp="31t93bvuzcalr">
              <button type="button" onClick={() => setFoundOpen(true)} className="flex w-full items-center gap-4 rounded-3xl border-2 border-dashed border-slate-300 p-6 text-left text-slate-500 transition-colors duration-150 ease-ville hover:border-ville-indigo hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-2016" data-mp="11rja3llykqf9">
                <span className="grid h-12 w-12 place-items-center rounded-full bg-slate-50" aria-hidden="true" data-id="element-2017" data-mp="nr8had1391rg">
                  <SearchIcon className="h-6 w-6" data-id="element-2018" data-mp="ityl8ej71run" />
                </span>
                <span data-id="element-2019" data-mp="e15g3pjtchi1">
                  <span className="block text-[15px] font-bold text-ville-navy" data-id="element-2020" data-mp="e0nmz1sg6jec">Animal found</span>
                  <span className="block text-sm text-slate-500" data-id="element-2021" data-mp="a0likkvbvbvd">Scan its collar or report it</span>
                </span>
              </button>
            </li>
          </ul>
        </section>

        <section aria-labelledby="todo-title" className="mt-14" data-id="element-2022" data-mp="1e6e10bxn9u">
          <h2 id="todo-title" className="text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-2023" data-mp="3r876f1jdzgcs">
            To do
          </h2>
          {todos.length === 0 ? <p className="mt-3 flex items-center gap-2 text-sm text-slate-500" data-id="element-2024" data-mp="3h6wgtqq9v76a">
              <CheckIcon className="h-4 w-4 text-ville-indigo" aria-hidden="true" data-id="element-2025" data-mp="3m1saswf2k4m1" />
              Everything is up to date.
            </p> : <ul className="mt-5 space-y-3" data-id="element-2026" data-mp="3w1svomsl6ssc">
              {todos.map(todo => <li key={`${todo.pet.id}-${todo.id}`} data-id="element-2027" data-mp="3w1aurcuzbqe3">
                  <Link to={`/my-pets/${todo.pet.id}`} className="group flex flex-wrap items-center gap-4 rounded-2xl border border-slate-200 bg-white px-5 py-4 transition-colors duration-150 ease-ville hover:border-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-2028" data-mp="2yekg18f9ody9">
                    <img src={todo.pet.photo} alt="" className="h-11 w-11 shrink-0 rounded-full object-cover" data-id="element-2029" data-mp="3d36uz90zf3oy" />
                    <span className="min-w-0 flex-1" data-id="element-2030" data-mp="2fmhxfrj2enld">
                      <span className="block text-[15px] font-bold text-ville-navy" data-id="element-2031" data-mp="2flq8gzjz3o42">
                        {todo.title} — {todo.pet.name}
                      </span>
                      <span className="block text-sm text-slate-500" data-id="element-2032" data-mp="2ckdbjbufu5ba">{todo.detail}</span>
                    </span>
                    <span className="inline-flex items-center gap-1.5 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville group-hover:text-ville-indigo" data-id="element-2033" data-mp="27ksej6ytw717">
                      {todo.cta}
                      <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-2034" data-mp="2hf0wx1u5ajln" />
                    </span>
                  </Link>
                </li>)}
            </ul>}
        </section>

        <PetRules data-id="element-2035" data-mp="1oq3odqfqk163" />
        <VetConnect data-id="element-2036" data-mp="23l9uedetzzzf" />
      </div>

      <FoundPetDialog open={foundOpen} onClose={() => setFoundOpen(false)} data-id="element-2037" data-mp="23ljks23sg95n" />
    </main>;
}